import React from 'react';

import Responsive from '@/components/Responsive';

import { ListItemProps, MenuItemProps } from '../../types';
import MenuItemsDesktop from './index.desktop';
import MenuItemsMobile from './index.mobile';

function MenuItems<T extends ListItemProps>(props: MenuItemProps<T>) {
  return (
    <Responsive>
      <Responsive.Default>
        <MenuItemsDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <MenuItemsMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
}

export default MenuItems;
